import { useEffect, useState } from 'react';

export function useSavedDescription(description: string) {
  const [saved, setSaved] = useState<string>();

  useEffect(() => setSaved(undefined), [description]);

  return [saved ?? description, setSaved] as const;
}

export default useSavedDescription;
